import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import ListaEventos from '../src/components/Eventos/ListaEventos'

import { Icon, Modal, Button } from 'semantic-ui-react'
import Moment from 'moment'

import 'react-toastify/dist/ReactToastify.css';

import Config from './Config'
import Eventos from '../src/services/Eventos'
import Usuarios from '../src/services/Usuarios'
import Mensagem from './components/Sistema/Mensagem'

import IsDevIndicator from '../src/components/Ambiente/IsDevIndicator'

class PagePresenca extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            message: false,
            eventoCongresso: null,
            tokenQrCode: this.props.match.params.t,
            tipocongresso: this.props.match.params.tipocongresso,
            optionLogin: this.props.match.params.tipocongresso,
            modalConfirmacaoSubstituicaoOpen: false,
            inscricoesEmChoqueSemPresenca: [],
            deMensagemMarcacaoPresenca: '',
            deMensagemErroMarcacaoPresenca: ''
        }
    }

    componentDidMount() {  
        Eventos.getInscricoesCongressista().then(result => {

            this.setState({
                ...this.state,
                eventosCongressista: result.data
            })
        })
        
        Eventos.getEventoCongresso(this.state.tokenQrCode)
            .then(response => {
        
                if (!response.sucesso) {
                this.setState({
                    ...this.state,
                    erro: true,
                    loading: false,
                    message:true
                })
                    return
                }

                this.setState({
                    ...this.state,
                    eventoCongresso: response.data,
                    congresso: response.data.Congresso
                })
                
                this.setState({
                    ...this.state,
                    icPresencaMarcada: false,
                    eventoCongresso: {
                        ...this.state.eventoCongresso,
                        diaEvento: Moment(this.state.eventoCongresso.InscricaoCongresso.dtInicioEvento).date(),
                        horaInicio: this.state.eventoCongresso.nuHoraInicio,
                        horaFim: this.state.eventoCongresso.nuHoraFim,
                        lblBotaoInscrever: "Marcar Presença"
                    }
                })
                
            }).catch((e) => {
              
            })

      Eventos.getCongressista().then(response => {

        if (!response.sucesso) {
          this.setState({
            ...this.state,
            erro: true,
            loading: false
          })
          return
        }

        if (response.data.idCongressoEncrypted !== Eventos.getIdCongresso()) {
          Usuarios.logout()
          response.data = null
        }

        this.setState({
          ...this.state,
          modalOpen: !Usuarios.isAuthenticated(),
          congressista: response.data
        })
      })

    }
    handleMarcarPresenca = (evento) => {
        this.setState({
          ...this.state,
          evento: evento,
          icAvaliacaoNPS: false
        }, () => {
          if (Usuarios.isAuthenticated()) {
            const inscricoesComPresenca = this.getInscricoesEmChoque(true);

            if (inscricoesComPresenca.length > 0) {
              this.setState({
                deMensagemErroMarcacaoPresenca: 'Não é possível marcar presença em uma atividade que conflita com outra atividade na qual você já possui presença registrada.'
              });
              return;
            }

            const inscricoesSemPresenca = this.getInscricoesEmChoque(false);

            if (inscricoesSemPresenca.length > 0) {
              this.setState({
                modalConfirmacaoSubstituicaoOpen: true,
                inscricoesEmChoqueSemPresenca: inscricoesSemPresenca,
                deMensagemErroMarcacaoPresenca: ''
              });
              return;
            }

            this.realizarMarcacaoPresenca(false);
          }
        })
      }

    confirmarSubstituicao = () => {
      this.setState({ modalConfirmacaoSubstituicaoOpen: false }, () => {
        this.realizarMarcacaoPresenca(true);
      });
    }

    cancelarSubstituicao = () => {
      this.setState({
        modalConfirmacaoSubstituicaoOpen: false,
        inscricoesEmChoqueSemPresenca: []
      });
    }

    realizarMarcacaoPresenca = (icSubstituiInscricoesEmChoqueSemPresenca) => {
      let user = Usuarios.getCurrentUser();
      Eventos.realizarParticipacaoEvento(
          this.state.congressista,
          user.optLogin,
          this.state.eventoCongresso.idEventoCongresso,
          user.iddkk,
          icSubstituiInscricoesEmChoqueSemPresenca).then(result => {
            const retornoPresenca = result.SetListaPresencaParticipanteResult;
            const erros = retornoPresenca && (retornoPresenca.$values || retornoPresenca);
            const mensagemErro = Array.isArray(erros) && erros.length > 0
              ? erros.map(item => item.deErro).filter(Boolean).join(' ')
              : '';

            if (mensagemErro) {
              if (!icSubstituiInscricoesEmChoqueSemPresenca &&
                  this.state.tokenQrCode &&
                  mensagemErro.indexOf('Foi encontrado um choque de horário com o evento') >= 0) {
                this.setState({
                  modalConfirmacaoSubstituicaoOpen: true,
                  inscricoesEmChoqueSemPresenca: this.getInscricoesEmChoqueSemPresencaDaMensagem(mensagemErro),
                  deMensagemErroMarcacaoPresenca: ''
                });
                return;
              }

              this.setState({
                ...this.state,
                loading: false,
                icPresencaMarcada: false,
                deMensagemMarcacaoPresenca: '',
                deMensagemErroMarcacaoPresenca: mensagemErro
              });
              return;
            }

            this.setState({
              ...this.state,
              eventos: [],
              loading: false,
              icPresencaMarcada: true,
              deMensagemMarcacaoPresenca: "Presença realizada",
              deMensagemErroMarcacaoPresenca: ''
            })
          })
    }

    getInscricoesEmChoqueSemPresencaDaMensagem = (mensagem) => {
      const titulo = mensagem.match(/evento "(.+?)"!/);

      return titulo ? [{ deTituloEvento: titulo[1] }] : [];
    }

    getInscricoesEmChoque = (icMarcouPresenca) => {
      const evento = this.state.eventoCongresso;
      const inicioEvento = this.getDataHoraEvento(
        evento.InscricaoCongresso.dtInicioEvento,
        evento.nuHoraInicio
      );
      const fimEvento = this.getDataHoraEvento(
        evento.InscricaoCongresso.dtFimEvento,
        evento.nuHoraFim
      );

      if (!inicioEvento || !fimEvento) {
        return [];
      }

      return (this.state.eventosCongressista || []).filter(inscricao => {
        const marcouPresenca = inscricao.icMarcadaPresenca === true || inscricao.icMarcouPresenca === true;

        if (inscricao.idEventoCongresso === evento.idEventoCongresso ||
            marcouPresenca !== icMarcouPresenca) {
          return false;
        }

        const inicioInscricao = this.getDataHoraEvento(inscricao.dtInicio, inscricao.horaInicio);
        const fimInscricao = this.getDataHoraEvento(inscricao.dtFim, inscricao.horaFim);

        return inicioInscricao && fimInscricao &&
          inicioEvento <= fimInscricao && fimEvento >= inicioInscricao;
      });
    }

    getDataHoraEvento = (data, hora) => {
      if (!data || !hora) {
        return null;
      }

      const dataPartes = data.split(' ')[0].split('/').map(Number);
      const horaPartes = hora.split(':').map(Number);

      if (dataPartes.length !== 3 || horaPartes.length !== 2 ||
          dataPartes.some(Number.isNaN) || horaPartes.some(Number.isNaN)) {
        return null;
      }

      return new Date(dataPartes[2], dataPartes[1] - 1, dataPartes[0], horaPartes[0], horaPartes[1]);
    }

    render() {

        const eventHandlers = {
          onLogin: (u, p, c) => this.handleSucessoLogin(u, p, c),
          onHandleInscricao: (e) => this.handleMarcarPresenca(e),
          onHandleExclusao: (e) => this.handleExclusao(e),
          onEndAvaliacaoNPS: (e) => this.handleEndAvaliacaoNPS(e),
        }

        var linkLogout = <Link to={`/${Eventos.getIdCongresso()}`} >
          Voltar para tela inicial <Icon name='log out' />
        </Link>
        return <div>
                <header>
                    { <div className="container">
                    {this.state.eventoCongresso !== null &&
                        <div className='mtop10'>
                       
                        <h1>{this.state.eventoCongresso.deTitulo}</h1>
                        <div ref={this.topRef}>
                            <span className='strong'>
                            <Icon name='calendar alternate outline' />
                            Período:
                            </span>
                            {` ${this.state.eventoCongresso.Congresso.dtInicioCongresso} a ${this.state.eventoCongresso.Congresso.dtFimCongresso}`}
                        </div>
                        <div className='mtop10'>
                            <span className='strong'>
                            {this.state.eventoCongresso.Congresso.icInscricoesAbertas &&
                                <Icon name='calendar check outline' />
                            }
                            {!this.state.eventoCongresso.Congresso.icInscricoesAbertas &&
                                <Icon name='calendar times outline' />
                            }
                            Inscrições Presença: 
                            </span>
                            {` ${this.state.eventoCongresso.Congresso.dtInicioInscricao} a ${this.state.eventoCongresso.Congresso.dtFimInscricao}`}
                        </div>
                        <IsDevIndicator content={`${Config.API_URL} - ${this.state.eventoCongresso.Congresso.idCongresso}`}></IsDevIndicator>

                        </div>
                    }
                    </div>}

                </header>   
                <div className='main-content tipoPart quaseLa' >

                    <div className='container'>

                    {linkLogout}

                    {this.state.eventoCongresso != null 
                      && this.state.eventoCongresso.icLancaPresenca === false 
                      && <Mensagem
                        erro
                        Header="Evento finalizado"
                        Content="" />}

                    {this.state.eventoCongresso != null 
                      && this.state.eventoCongresso.icLancaPresenca === true 
                      && this.state.eventoCongresso && 
                        <ListaEventos
                                titulo={`Marcar Presença`}
                                source={[this.state.eventoCongresso]}
                                eventHandlers={eventHandlers} />
                    }

                    { this.state.icPresencaMarcada &&
                      <Mensagem
                        success
                        Header={this.state.deMensagemMarcacaoPresenca}
                        Content="" />
                    }

                    { this.state.deMensagemErroMarcacaoPresenca &&
                      <Mensagem
                        erro
                        Header={this.state.deMensagemErroMarcacaoPresenca}
                        Content="" />
                    }

                    <Modal
                      closeOnEscape={false}
                      closeOnDimmerClick={false}
                      open={this.state.modalConfirmacaoSubstituicaoOpen}
                      onClose={() => this.cancelarSubstituicao()}
                      dimmer='inverted'>
                      <Modal.Content className='resetCorners resetBorders'>
                        <Modal.Description className='resetCorners resetBorders'>
                          <div className='main-content tipoPart modal'>
                            <div className='container'>
                              <div className='ui warning message resetCorners resetBorders'>
                                <div className='header' style={{ marginBottom: '10px' }}>
                                  Confirmar substituição de inscrições
                                </div>
                                <p style={{ marginBottom: '10px' }}>
                                  Você já está inscrito(a) em atividades no mesmo horário. Ao confirmar, essas inscrições serão canceladas e sua presença será registrada nesta atividade.
                                </p>
                                <div className='ui list'>
                                  {this.state.inscricoesEmChoqueSemPresenca.map(inscricao =>
                                    <div className='item' key={inscricao.idEventoCongresso || inscricao.deTituloEvento || inscricao.deEvento}>
                                      {inscricao.deTituloEvento || inscricao.deEvento}
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className='text-right'>
                                <Button className='button p' onClick={() => this.cancelarSubstituicao()} content='Cancelar' />
                                <Button className='button type1 p' onClick={() => this.confirmarSubstituicao()} content='Confirmar presença' />
                              </div>
                            </div>
                          </div>
                        </Modal.Description>
                      </Modal.Content>
                    </Modal>

                    </div>
                </div>
        </div>
    }
}

export default withRouter(PagePresenca)



// WEBPACK FOOTER //
// ./src/PagePresenca.js